import React, { Fragment, useState } from 'react'
import PDFIcon from '../../assets/pdf.png'
import { NavLink } from 'react-router-dom'
import { useQuery } from 'react-query'
import { getLatestGenSnap } from 'services/request/Dashboard'
import ImageView from 'components/ImageView'
import { RiMessageFill } from 'react-icons/ri'
import { LoadingComponent } from 'components/LoadingComponent'

function GenSnapIntelUpdate({ dataContainer }) {
    const makeUrlsClickable = (text) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g
        return text.split(urlRegex).map((part, index) => {
            if (part.match(urlRegex)) {
                return (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-blue-600 hover:underline break-all font-bold"
                    >
                        {part}
                    </a>
                )
            }
            return part
        })
    }

    const [genSnap, setGenSnap] = useState()
    const [selectedImage, setSelectedImage] = useState(null)

    const { data, isLoading } = useQuery(
        ['getLatestGenSnap', dataContainer?.id],
        () => getLatestGenSnap(dataContainer?.id),
        {
            onSuccess: (data) => setGenSnap(data),
        }
    )

    if (isLoading) {
        return <LoadingComponent title={'Recent General SnapIntel Updates'} />
    }

    const getLatestDate = (snapIntel) => {
        if (!snapIntel) return 'No Date Available'

        const dates = Object.keys(snapIntel)
        if (dates.length === 0) return 'No Date Available'

        const latestDate = dates.sort((a, b) => new Date(b) - new Date(a))[0]
        return latestDate
    }

    const latestDate = dataContainer?.latest_general_snapintel
        ? getLatestDate(dataContainer?.latest_general_snapintel)
        : 'No Date Available'

    const latestSnapData =
        latestDate !== 'No Date Available' && dataContainer?.latest_general_snapintel
            ? [...dataContainer?.latest_general_snapintel[latestDate]].sort((a, b) => {
                  if (a.created_at && b.created_at) {
                      return new Date(a.created_at) - new Date(b.created_at)
                  } else if (a.updated_at && b.updated_at) {
                      return new Date(a.updated_at) - new Date(b.updated_at)
                  } else {
                      return a.id - b.id
                  }
              })
            : []

    return (
        <div className="w-full flex flex-col">
            <div className="w-full h-full max-h-[470px] overflow-y-auto px-5 flex flex-col gap-3 bg-gray-200 py-5 rounded-b-md">
                {selectedImage && (
                    <ImageView image={selectedImage} onClose={() => setSelectedImage(null)} />
                )}
                {dataContainer?.latest_general_snapintel && latestDate !== 'No Date Available' ? (
                    latestSnapData && latestSnapData?.length > 0 ? (
                        <div key={dataContainer.id}>
                            {latestSnapData?.map((gensnap, gensnapIndex) => (
                                <Fragment key={gensnapIndex}>
                                    <div>
                                        <button className="transition-all duration-300 px-4 py-2 w-3/4 bg-main text-white text-sm text-left rounded-md shadow-md hover:translate-x-2">
                                            {gensnap?.question?.question}
                                        </button>
                                        <div className="w-full flex flex-col justify-end items-end my-5">
                                            <p className="animate_fade_up max-w-[75%] w-fit self-end break-words text-sm bg-white px-4 py-2 shadow-sm rounded-md bg-opacity-70">
                                                <span className="text-xs font-bold items-end justify-end flex">
                                                    {gensnap?.user?.fullname}
                                                </span>
                                                <p
                                                    style={{ whiteSpace: 'pre-line' }}
                                                    className="text-justify"
                                                >
                                                    {gensnap.answer &&
                                                        makeUrlsClickable(gensnap.answer).map(
                                                            (part, index) => (
                                                                <React.Fragment key={index}>
                                                                    {part}
                                                                </React.Fragment>
                                                            )
                                                        )}
                                                </p>
                                                {gensnap?.attachments &&
                                                    gensnap?.attachments?.length > 0 && (
                                                        <React.Fragment>
                                                            {gensnap?.attachments.filter(
                                                                (attachment) =>
                                                                    attachment.type === 'image'
                                                            )?.length > 1 ? (
                                                                <div className="grid grid-cols-4 gap-1">
                                                                    {gensnap?.attachments
                                                                        .filter(
                                                                            (attachment) =>
                                                                                attachment.type ===
                                                                                'image'
                                                                        )
                                                                        .map((attachment) => (
                                                                            <div
                                                                                className="flex items-start justify-start w-full"
                                                                                key={attachment.id}
                                                                            >
                                                                                <img
                                                                                    className="transition-all duration-300 w-[200px] h-[100px] cursor-pointer hover:brightness-50"
                                                                                    src={
                                                                                        attachment.filename
                                                                                    }
                                                                                    alt="Attachment"
                                                                                    onClick={() =>
                                                                                        setSelectedImage(
                                                                                            attachment.filename
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            ) : (
                                                                gensnap?.attachments
                                                                    .filter(
                                                                        (attachment) =>
                                                                            attachment.type ===
                                                                            'image'
                                                                    )
                                                                    .map((attachment) => (
                                                                        <div
                                                                            className="flex items-start justify-start w-full"
                                                                            key={attachment.id}
                                                                        >
                                                                            <img
                                                                                className="transition-all duration-300 w-[200px] cursor-pointer hover:brightness-50"
                                                                                src={
                                                                                    attachment.filename
                                                                                }
                                                                                alt="Attachment"
                                                                                onClick={() =>
                                                                                    setSelectedImage(
                                                                                        attachment.filename
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ))
                                                            )}
                                                            <div>
                                                                {gensnap?.attachments
                                                                    .filter(
                                                                        (attachment) =>
                                                                            attachment.type !==
                                                                            'image'
                                                                    )
                                                                    .map((attachment) => (
                                                                        <div
                                                                            className="flex items-start justify-start w-full"
                                                                            key={attachment.id}
                                                                        >
                                                                            {attachment.type ===
                                                                            'file' ? (
                                                                                <NavLink
                                                                                    to={
                                                                                        attachment.filename
                                                                                    }
                                                                                    target="__blank"
                                                                                    className="transition-all duration-300 flex gap-4 h-fit items-center bg-[#c6c6c6] px-4 py-2 rounded-lg shadow-inner hover:bg-[#9a9a9a]"
                                                                                >
                                                                                    <img
                                                                                        className="w-8"
                                                                                        src={
                                                                                            PDFIcon
                                                                                        }
                                                                                        alt="TEXT_FILE"
                                                                                    />
                                                                                    <p className="text-left text-xs break-all truncate-multiline-2">
                                                                                        {
                                                                                            attachment.filename
                                                                                        }
                                                                                    </p>
                                                                                </NavLink>
                                                                            ) : null}
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        </React.Fragment>
                                                    )}{' '}
                                                <span className="text-xs mt-1 text-grey">
                                                    <span>Date: </span> {gensnap.updated_at}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </Fragment>
                            ))}
                        </div>
                    ) : (
                        <div className="w-full h-full flex flex-col justify-center items-center animate_zoom_in">
                            <p className="text-4xl text-main">
                                <RiMessageFill />
                            </p>
                            <p className="text-2xl text-main">Questionnaire not completed</p>
                        </div>
                    )
                ) : (
                    <div className="w-full h-full flex flex-col justify-center items-center animate_zoom_in">
                        <p className="text-4xl text-main">
                            <RiMessageFill />
                        </p>
                        <p className="text-2xl text-main">No Record</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default GenSnapIntelUpdate
